import Addon from "./input-group-addon.svelte"
import Button from "./input-group-button.svelte"
import Input from "./input-group-input.svelte"
import Text from "./input-group-text.svelte"
import Textarea from "./input-group-textarea.svelte"
import Root from "./input-group.svelte"

export {
  Root,
  Addon,
  Button,
  Input,
  Text,
  Textarea,
  //
  Root as InputGroup,
  Addon as InputGroupAddon,
  Button as InputGroupButton,
  Input as InputGroupInput,
  Text as InputGroupText,
  Textarea as InputGroupTextarea,
}
